module.exports = __webpack_public_path__ + "img/updown2.867835bb.png";